<template>
  <!-- section5 -->
  <div class="section5-wrap" id="section5">
    <div class="section5">
      <div class="section-title">
        <div class="section-title-zh">5.售后服务</div>
        <div class="section-title-en">AFTER-SALE SERVICE</div>
      </div>
      <div class="section5-content">
        <div class="item-view" style="margin-bottom: 84px">
          <div class="item-view-title">产品交付规范化管理</div>
          <img
            src="../../assets/product/section5_1.png"
            alt="img"
            class="item-view-img"
          />
        </div>
        <div class="item-view">
          <div class="item-view-title">售后服务规范</div>
          <img
            src="../../assets/product/section5_2.png"
            alt="img"
            class="item-view-img"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "productItem3",
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
.section-title {
  position: relative;
  height: 74px;
  .section-title-zh {
    z-index: 9;
    width: 100%;
    position: absolute;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5680b9;
    text-align: center;
  }
  .section-title-en {
    width: 100%;
    position: absolute;
    font-size: 50px;
    font-family: MiSans;
    font-weight: 400;
    color: #f5f5f5;
    text-align: center;
  }
}
// section5
.section5-wrap {
  width: 100%;
  background: #fff;
  .section5 {
    padding: 100px 0;
    .section5-content {
      width: 1200px;
      margin: 50px auto 50px;
      .item-view {
        .item-view-title {
          text-align: center;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 48px;
          margin-bottom: 60px;
        }
        .item-view-desc {
          text-align: center;
          margin-bottom: 66px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 36px;
        }
        .item-view-img {
          width: 1182px;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
